// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-Xnc{display:flex;flex-direction:column;gap:16px}.NXNw{all:unset;align-items:center;color:var(--main-blue);cursor:pointer;display:inline-flex;gap:8px}.CX-w{--s:20px;height:20px;height:var(--s);width:20px;width:var(--s)}.EBI5{color:currentColor;font-family:\"Roboto\",sans-serif!important;font-size:14px;font-style:normal;font-weight:400;letter-spacing:.17px;line-height:20px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.UBSZ{all:unset;color:var(--grey-400);cursor:pointer;display:flex;flex-direction:column;flex-shrink:0;margin-top:18px}.R7qc{--s:20px;height:20px;height:var(--s);width:20px;width:var(--s)}._0Fdf{display:flex;gap:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionSidebarChatMessage": "-Xnc",
	"actionSidebarChatMessageButton": "NXNw",
	"actionSidebarChatMessageButtonIcon": "CX-w",
	"actionSidebarChatMessageButtonLabel": "EBI5",
	"actionSidebarChatMessageRemoveTitle": "UBSZ",
	"actionSidebarChatMessageRemoveTitleIcon": "R7qc",
	"actionSidebarChatMessageTitleGroup": "_0Fdf"
};
module.exports = ___CSS_LOADER_EXPORT___;
